import Close from '@vtex/styleguide/lib/icon/Close';

type CloseIconContainerProps = {
	handleClick?: () => void;
};

const CloseIconContainer = ({ handleClick }: CloseIconContainerProps) => {
	return (
		<div className={`flex vtex-minicart-2-x-closeIconContainer`}>
			<button
				onClick={() => handleClick && handleClick()}
				className={`vtex-minicart-2-x-closeIconButton pa4 pointer bg-transparent transparent bn pointer`}
			>
				<Close size={30} />
			</button>
		</div>
	);
};

export default CloseIconContainer;
